export class Periodo {
    codigo: number;
	codigoiter: number;
	petCodigo: number;
	nombre: string;
	periodosInsc: string;
	periodosNoInsc: string;
	anno: number;
	perAnnointer: number;
	periodo: number;
	periodo1: number;
	fechaInicio: Date;
	fechaFin: Date;
}
